<template>
  <no-auth v-if="!hasAuthorize.list"></no-auth>
  <div :class="{ 'o-card': !tab }" v-else>
    <Table
      no-card
      :title="$t(`${name}.title`)"
      :description="$t(`${name}.description`)"
      i18n
      :loading="getItemsLoading"
      :items="getItems(page)"
      checkable
      :checkValue="checkedList"
      :status="getStatus"
      @change:sort="SET_CHANGE_SORT"
      @change:checkedList="checkedList = $event"
      @change:selectAllWithoutPage="SET_CHECKED_ALL"
      :headers="headers"
      :page="page"
      :count="getItemCount"
      :pages="getItemPages"
      :searchValue="search"
      @change:search="setSearch"
      @change:page="setChangedPage"
      :searchPlaceholder="$t(`${name}.searchPlaceholder`)"
    >
      <template #new-button>
        <div class="u-display-flex u-width-100% u-justify-content-flex-end">
          <ExcelExport
            :fileName="`${name}-export-${date()}`"
            :fields="exportFields"
            :data="checkedList.length > 0 ? checkedList : getItems()"
          >
            <template #button="{ showExcell }">
              <Button
                @click="showExcell()"
                variant="light-success"
                class="u-margin-right-xsmall"
              >
                <i class="icofont-arrow-up"></i> {{ $t("common.export") }}
              </Button>
            </template>
          </ExcelExport>
          <Button
            variant="light-primary"
            v-if="hasAuthorize.add"
            @click="newMainProject = true"
          >
            + {{ $t(`${name}.add`) }}
          </Button>
        </div>
      </template>
      <template #name="{ item }">
        <div class="u-cursor-pointer">
          <router-link
            :to="{
              name: `main-projects-id`,
              params: { mainProjectId: item.id },
            }"
          >
            <span> {{ item.title }} </span>
          </router-link>
        </div>
      </template>
      <template #info="{ item }">
        <div class="u-margin-bottom-xsmall">
          <chip
            class="u-margin-0"
            :variant="item.isActive ? 'success' : 'danger'"
          >
            {{ item.isActive ? $tc("common.active") : $tc("common.passive") }}
          </chip>
        </div>
        <div class="u-color-primary">
          <i class="icofont-calendar"></i> {{ date(item.createdDate) }}
        </div>
      </template>
      <template #updatedDate="{ item }">
        <div class="u-color-primary">
          <i class="icofont-calendar"></i> {{ date(item.updatedDate) }}
        </div>
      </template>
      <template #seriesInfo="{ item }">
        <div class="u-color-primary">
          {{ item.seriesInfo.title }}
        </div>
      </template>
      <template #action="{ item }">
        <div
          class="u-display-flex u-align-items-center u-justify-content-flex-end"
        >
          <Dropdown align="right">
            <template #title>
              <div class="u-font-size-xlarge u-padding-left">
                <i class="icofont-bubble-down"></i>
              </div>
            </template>
            <template #content>
              <ul class="c-list">
                <li
                  class="c-list__item"
                  :class="{
                    'c-list__item--disabled': !hasAuthorize.edit,
                  }"
                  @click="showDetail(item)"
                  v-if="hasAuthorize.edit"
                >
                  <span>
                    <i class="icofont-edit u-margin-right-xsmall"></i>
                    {{ $t("common.edit") }}</span
                  >
                </li>
                <router-link
                  v-if="hasAuthorize.getById"
                  :to="{
                    name: `main-projects-id`,
                    params: { mainProjectId: item.id },
                  }"
                >
                  <li class="c-list__item">
                    <span>
                      <i class="icofont-eye u-margin-right-xsmall"></i>
                      {{ $t("common.goToDetail") }}</span
                    >
                  </li>
                </router-link>
                <li
                  @click="REMOVE_TO(item)"
                  class="c-list__item"
                  :class="{
                    'c-list__item--disabled': !hasAuthorize.delete,
                  }"
                  v-if="hasAuthorize.delete"
                >
                  <span>
                    <i class="icofont-trash u-margin-right-xsmall"></i>
                    {{ $t("common.remove") }}</span
                  >
                </li>
              </ul>
            </template>
          </Dropdown>
        </div>
      </template>
    </Table>
    <RemoveModal @ok="REMOVE_ITEM" v-model="removeModal.status"></RemoveModal>

    <MainProjectForm
      edit
      @refresh="getItemsOfPage"
      v-model="showDetailModal.status"
      :form="showDetailModal.item"
    ></MainProjectForm>
    <MainProjectForm
      v-model="newMainProject"
      @refresh="getItemsOfPage"
    ></MainProjectForm>
  </div>
</template>

<script>
import Table from "@/components/Base/Table/index.vue";
import DateHelper from "@/helpers/date";
import { mapGetters } from "vuex";
import Button from "../Base/Button.vue";
import Dropdown from "../Base/Dropdown.vue";
import RemoveModal from "@/components/Shared/RemoveModal/index.vue";
import ExcelExport from "../Base/ExcelExport.vue";
import Requests from "@/services/Requests";
import mainProjectExportFields from "./mainProjectExportFields";
import MainProjectForm from "./MainProjectForm.vue";
import Chip from "../Base/Chip.vue";
export default {
  components: {
    Dropdown,
    RemoveModal,
    Table,
    Button,
    ExcelExport,
    MainProjectForm,
    Chip,
  },
  mixins: [mainProjectExportFields],
  props: {
    query: {
      type: Object,
      default: () => {
        return {};
      },
    },
    noFilter: {
      type: Boolean,
      default: false,
    },
    tab: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      name: "mainProject",
      checkedList: [],
      showLockedModal: false,
      showRemoveModal: false,
      newMainProject: false,
      filter: {},
      sort: {},
      get: {
        title: "mainProjects",
        dispatch: "getMainProjects",
      },
      update: {
        title: "updateMainProjects",
        dispatch: "updateMainProject",
        lockedStatus: "isLocked",
      },
      remove: {
        title: "removeMainProjects",
        dispatch: "removeMainProject",
      },
      page: 1,
      search: "",
      headers: [
        {
          col: 12,
          sm: 3,
          md: 3,
          lg: 3,
          title: "project.name",
          value: "name",
          sortable: true,
        },
        {
          col: 10,
          sm: 3,
          md: 3,
          lg: 3,
          title: "common.info",
          value: "info",
          sortable: true,
        },
        {
          col: 10,
          sm: 3,
          md: 3,
          lg: 3,
          title: "cyclesForm.series",
          value: "seriesInfo",
        },
        {
          col: 2,
          sm: 1,
          md: 1,
          lg: 1,
          align: "right",
          title: "common.action",
          value: "action",
        },
      ],
      seriesId: "",
      removeModal: { status: false, item: {} },
      lockedModal: { status: false, item: {} },
      showDetailModal: { status: false, adminDetailStatus: false, item: null },
    };
  },
  computed: {
    ...mapGetters({
      getItems: "getMainProjects",
      getItemsLoading: "getMainProjectsLoading",
      getItemPages: "getMainProjectPages",
      getItemCount: "getMainProjectCount",
      getActiveUser: "getActiveUser",
      getStatus: "getMainProjectStatus",
    }),
    exportFields() {
      if (this.getItems().length === 0) return {};
      return this.getExcelFields();
    },
    hasAuthorize() {
      const list = this.$store.getters["getAuthorizeList"];
      const activeUser = this.$store.getters["getActiveUser"];
      if (activeUser.userInfo.role === "Admin")
        return {
          list: true,
          add: true,
          edit: true,
          delete: true,
        };
      return {
        list: !list.some(
          (item) =>
            item.authorityInfo.controller === "MainProjects" &&
            item.authorityInfo.action === "GetAll"
        ),
        add: !list.some(
          (item) =>
            item.authorityInfo.controller === "MainProjects" &&
            item.authorityInfo.action === "Create"
        ),
        edit: !list.some(
          (item) =>
            item.authorityInfo.controller === "MainProjects" &&
            item.authorityInfo.action === "Update"
        ),
        delete: !list.some(
          (item) =>
            item.authorityInfo.controller === "MainProjects" &&
            item.authorityInfo.action === "Delete"
        ),
        getById: !list.some(
          (item) =>
            item.authorityInfo.controller === "MainProjects" &&
            item.authorityInfo.action === "GetById"
        ),
        locked: !list.some(
          (item) =>
            item.authorityInfo.controller === "MainProjects" &&
            item.authorityInfo.action === "UpdateLockStatus"
        ),
      };
    },
  },
  methods: {
    SET_CHANGE_SORT(headers) {
      const sortedHeaders = headers.filter((item) => item.sort);
      if (sortedHeaders.length === 0) {
        this.sort = {};
        this.getItemsOfPage();
      } else {
        const sort = sortedHeaders[0];
        if (sort.sort.includes("name")) {
          const value = sort.sort.split("-")[1];
          this.sort = {
            sort: value.toUpperCase(),
            sortFilter: "ALPHABETIC",
          };
        } else if (sort.sort.includes("info")) {
          const value = sort.sort.split("-")[1];
          this.sort = {
            sort: value.toUpperCase(),
            sortFilter: "DATE",
          };
        }
        this.getItemsOfPage();
      }
    },
    async SET_CHECKED_ALL(data) {
      if (data) {
        this.$store.dispatch("SET_ACTION_MODAL", {
          isLoading: true,
          status: true,
        });
        const response = await Requests.Project.GetAll({
          query: { page: 1, limit: this.getItemCount, search: this.search },
        });
        if (response.message === "OK") {
          console.log(response.data);

          this.checkedList = [...response.data.items];
        }
        this.$store.dispatch("SET_ACTION_MODAL", {
          isLoading: false,
          status: false,
        });
      }
    },
    showDetail(item) {
      this.showDetailModal = {
        status: true,
        adminDetailStatus: false,
        item: item,
      };
    },
    showAdminDetail(item) {
      this.showDetailModal = {
        status: false,
        adminDetailStatus: true,
        item: item,
      };
    },
    date(value = new Date()) {
      const date = new DateHelper(this.$i18n.locale);
      return date.format(value);
    },
    SET_LOCKED_DESCRIPTION() {
      return this.lockedModal.item.isLocked ? "unlocked" : "locked";
    },
    REMOVE_TO(item) {
      this.removeModal = {
        status: true,
        item: item,
      };
    },
    async REMOVE_ITEM(loading) {
      loading(true);

      const response = await this.$store.dispatch(this.remove.dispatch, {
        id: this.removeModal.item.id,
      });
      if (response.message === "OK") {
        this.getItemsOfPage();
        this.$store.dispatch("SET_ACTION_MODAL", {
          isLoading: false,
          status: true,
          message: this.$t(`${this.remove.title}.success`),
          variant: "success",
          duration: 2500,
        });
      } else {
        this.$store.dispatch("SET_ACTION_MODAL", {
          isLoading: false,
          status: true,
          message: this.$t(`${this.remove.title}.error`),
          variant: "danger",
          duration: 2500,
        });
      }
      loading(false);
    },
    LOCKED_TO(item) {
      if (!item.isPermission) return;
      this.lockedModal = {
        status: true,
        item: item,
      };
    },
    async LOCKED_ITEM(loading) {
      loading(true);
      const response = await Requests.Project.UpdateLockStatus(
        { params: { id: this.lockedModal.item.id } },
        { isLocked: !this.lockedModal.item.isLocked }
      );
      if (response.message === "OK") {
        this.getItemsOfPage();
        this.$store.dispatch("SET_ACTION_MODAL", {
          isLoading: false,
          status: true,
          message: this.$t(`${this.update.title}.success`),
          variant: "success",
          duration: 2500,
        });
      } else {
        this.$store.dispatch("SET_ACTION_MODAL", {
          isLoading: false,
          status: true,
          message: this.$t(`${this.update.title}.error`),
          variant: "danger",
          duration: 2500,
        });
      }
      loading(false);
    },
    setQuery() {
      const page = Number(this.$route.query.page);
      const seriesId = this.$route.query.seriesId;
      const search = this.$route.query.search;
      if (!isNaN(page)) this.page = page;
      if (search) this.search = search;
      if (seriesId) this.seriesId = seriesId;
      this.getItemsOfPage();
    },
    getItemsOfPage() {
      this.removeModal = { status: false, item: {} };
      this.lockedModal = { status: false, item: {} };
      this.$store.dispatch(this.get.dispatch, {
        query: {
          limit: 10,
          page: this.page,
          search: this.search,
          seriesId: this.seriesId,
          ...this.filter,
          ...this.sort,
          ...this.query,
        },
        force: true,
      });
    },
    setSearch(search) {
      this.search = search;
      this.page = 1;
      this.$router.replace({
        query: { ...this.$route.query, search: this.search, page: 1 },
      });
      this.getItemsOfPage();
    },
    setChangedPage(page) {
      this.$router.replace({
        query: { ...this.$route.query, page: page },
      });
      this.page = page;
      this.getItemsOfPage();
    },
    setFilter(filter) {
      const filterScoped = {
        type: filter.type || "",
        isLocked:
          filter.isLocked == null
            ? ""
            : filter.isLocked
            ? "true"
            : "false" || "",
        userId: filter.user?.id || "",
        batteryId: filter.batteryId?.id || "",
      };
      // remove
      this.filter = filterScoped;
      this.getItemsOfPage(filterScoped);
    },
  },
  mounted() {
    this.setQuery();
  },
};
</script>

<style></style>
